if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.autoplayTimeout = null;
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.slides = this.querySelectorAll('.swiper-slide');
      this.dots = this.querySelectorAll('.dot');
      this.prevButton = this.querySelector('.prev');
      this.nextButton = this.querySelector('.next');
      
      this.currentSlide = 0;
      this.slideCount = this.slides.length;
      
      this.setupSlideshow();
    }

    setupSlideshow() {
      // Guard against empty slideshow
      if (this.slideCount === 0) return;
      
      // Hide all slides except first
      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = 'none';
      });

      // Setup controls
      if (this.showArrows) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      if (this.showDots) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });
      }

      // Start autoplay if enabled
      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.autoplayTimeout = setInterval(() => {
        this.nextSlide();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimeout) {
        clearInterval(this.autoplayTimeout);
        this.autoplayTimeout = null;
      }
    }

    nextSlide() {
      this.goToSlide((this.currentSlide + 1) % this.slideCount);
    }

    prevSlide() {
      this.goToSlide(this.currentSlide === 0 ? this.slideCount - 1 : this.currentSlide - 1);
    }

    goToSlide(index) {
      // Guard against invalid index or missing slides
      if (!this.slides.length || index < 0 || index >= this.slideCount) return;
      
      // Hide current slide
      this.slides[this.currentSlide].style.display = 'none';
      if (this.showDots) {
        this.dots[this.currentSlide]?.classList.remove('active');
      }

      // Show new slide
      this.currentSlide = index;
      this.slides[this.currentSlide].style.display = 'block';
      if (this.showDots) {
        this.dots[this.currentSlide]?.classList.add('active');
      }

      // Reset autoplay if enabled
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
